import React from 'react';
import styles from '../../styles/cr.module.scss';
import { ChoiceGroup, IChoiceGroupProps } from '@fluentui/react/lib/ChoiceGroup';
import { FieldErrorMessage, FieldHistory } from './FieldDecorators';

export interface ICrChoiceGroupProps extends IChoiceGroupProps {
    history?: string;
    errorMessage?: string;
    labelBold?: boolean;
}

export const CrChoiceGroup = ({ className, history, errorMessage, labelBold, ...otherProps }: ICrChoiceGroupProps): React.ReactElement => {
    return (
        <div className={`${className} ${labelBold ? styles.choiceGroupLabelBold : ''}`}>
            <div className={styles.cr}>
                <ChoiceGroup
                    {...otherProps}
                />
                {history && <FieldHistory value={history} />}
                {errorMessage && <FieldErrorMessage value={errorMessage} />}
            </div>
        </div>
    );
};
